import React from 'react'
import { FaAt, FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const crtYear = new Date().getFullYear();

  const iconClassName = '';
  return (
    <div className="w-full backdrop-blur-sm text-xs mt-5 lg:mt-10 bg-light-accent dark:bg-dark-accent text-dark dark:text-light">
    {/* Navbar */}
      <footer className='flex justify-between items-center max-w-3xl p-5 m-auto border-t border-dark dark:border-light'>
        <div className='flex items-center'>
          © Philipp Wulff
          &nbsp;&middot;&nbsp;
          {crtYear}
        </div>
        {/* Hide this line on small screens */}
        <span className='hidden sm:flex'>
          Made with 🥨 in Munich
        </span>
        <div className='flex items-center justify-between w-16 text-2xl'>
          <a href='https://github.com/philippwulff' target='_blank' className={iconClassName}><FaGithub/></a>
          <a href='https://www.linkedin.com/in/philippwulff/' target='_blank' className={iconClassName}><FaLinkedin/></a>
          {/* <a href='mailto:philipp.wulff@tum.de' className={iconClassName}><FaAt/></a> */}
        </div>
      </footer>
    </div>
  )
}

export default Footer